<template>
    <div class="services-calendar view">
        <transition name="v-transition-notification">
            <nks-notification v-cloak v-if="showNotification" :eventsNbr="eventsNbr"></nks-notification>
        </transition>
        <transition name="v-transition-actions">
            <nks-actions v-cloak v-if="showAction" :eventDate="selectedEventDate" :eventActions="selectedEventActions"></nks-actions>
        </transition>
        <transition name="v-transition-calendar">
            <full-calendar
                    v-show="showCalendar"
                    :events="fcEvents"
                    firstDay="1"
                    :monthNames="monthNames"
                    :weekNames="weekNames"
                    @eventClick="eventClick"
                    ></full-calendar>
        </transition>
    </div>
</template>

<script>

    import FullCalendar from 'vue-fullcalendar';
    import Actions from './Actions.vue';
    import Notification from './Notification.vue';
    import { eventBus } from '../../main';

    export default {
        components: {
            'full-calendar': FullCalendar,
            'nks-actions': Actions,
            'nks-notification': Notification
        },
        data() {
            return {
                //gestion des elements du calendrier
                fcEvents: [],

                monthNames : ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','November','Décembre'],
                weekNames :  ['lun','mar','mer','jeu','ven','sam','dim'],

                //affichage du composant actions
                showAction: false,

                //affichage du composant calendar
                showCalendar: true,

                //affichage du composant notification
                showNotification: false,
                eventsNbr: '',

                //date de l'evement selectionné tramsmis au composant actions
                selectedEventDate: '',

                //actions de l'evenemnt selectionné tramsmis au composant actions
                selectedEventActions: [],

                //actions correspond à toutes les actions à mener (titre, text, classIcon)
                actions: {}
            }
        },
        methods : {
            addEventsOnCalendar(data) {
                //on recuperer la liste des actions à mener
                for (let key in data.actions) {
                    this.actions[key] = data.actions[key];
                }

                //on inscrit l'evenement dans le calendrier
                //un evenement est constitué de jours de l'ope à proprement parler et de jours avant et apres l'ope
                //afin d'avoir un controle sur les jours, chaque jour sera un evenement enregistré dans le composant fullCalendar

                let eventsDates = [];


                for(let i = 0; i < data.events.length; i++) {

                    //on extrait l'evenement
                    let event = data.events[i];

                    //on commence par ajouter les dates de l'ope lié à l'evenement
                    let ope = {
                        start: event.ope.start,
                        end: event.ope.end,
                        name: event.name,
                        cssClass: 'ope'
                    };
                    eventsDates.push(ope);

                    //puis on ajoute les jours liés à l'evenement seulement si il y des actions à mener
                    for (let y = 0; y < event.days.length; y++) {
                        if (event.days[y].actions != null) {
                            let eventDay = {
                                start: this.getEventDay(event.start, y),
                                cssClass: 'level' + Object.keys(event.days[y].actions).length,
                                actions: event.days[y].actions
                            };
                            eventsDates.push(eventDay);
                        }
                    }
                }
                this.fcEvents = eventsDates;
            },
            getEventDay(startDay, addedDay) {
                //a partir de la date de l'evenement on indique le niveau de tache à accomplir sur chaque jour
                //on transforme la date de depart de l'evenement en timestamp
                let startDayTimestamp = new Date(startDay).getTime();
                let dayTimestamp = startDayTimestamp + addedDay * 86400000;

                let toYear = new Date(dayTimestamp).getFullYear();
                let toMonth = new Date(dayTimestamp).getMonth()+1;
                let toDate = new Date(dayTimestamp).getDate();

                return toYear+'-'+this.twoDigit(toMonth)+'-'+this.twoDigit(toDate);
            },
            twoDigit(date) {
                return date < 10 ? '0' + date : '' + date; // ('' + date) for string result
            },
            eventClick(evt) {
                this.selectedEventActions = [];
                //on recupere la date de l'evenement selectionne
                //la propriété "start" de l'evenement cliqué correspond à la date de départ elle est de la forme '2017-1-28'
                let eventDate = new Date(evt.start);
                this.selectedEventDate = eventDate.getDate()+' '+this.monthNames[eventDate.getMonth()];

                //Pour chaque action à mener
                for(let key in evt.actions) {
                    //on recupere le titre et le texte de l'action à mener et l'icone a afficher
                    let action = {
                        title: evt.actions[key].title,
                        text: evt.actions[key].text,
                        imgSrc: this.actions[key].imgSrc
                    };

                    this.selectedEventActions.push(action);

                }

                //on affiche le composant action et on "masque" le calendrier
                this.showAction = true;
                this.showCalendar = false;
            },
        },
        created() {
            this.addEventsOnCalendar({
                actions: this.$store.state.calendar.actions,
                events: this.$store.state.calendar.events
            });

            //ajout des listener pour les evenement de fermeture des actions et notification
            eventBus.$on('actions:close', () => {
                //on masque le composant action et on affiche le calendrier
                this.showAction = false;
                this.showCalendar = true;
                //on remet à zero le tableau d'actions à mener
                this.selectedEventActions = [];
            });

            eventBus.$on('notification:close', () => {
                this.showNotification = false;
            });

            eventBus.$on('notification:clicked', () => {

                //on recupere l'element today
                let $datesEvents = $('.dates-events');
                let $today = $datesEvents.find('.today');
                $today.find('[class*="level"]').trigger( "click" );

                //on recupere l'element today afin de produire l'evenement du clic
                this.showNotification = false;
            });
        },
        mounted() {
            //on dans le calendrier si le jour actuel contient des actions à effectuer
            //si c'est le cas on affiche la notification au bout d'une seconde
            let $datesEvents = $('.dates-events');
            let $today = $datesEvents.find('.today');

            if($today.find('[class*="level"]').length) {
                //on recupere le nombre d'action a realiser
                //on recupere pour cela la liste des class de l'element contenant la class level


                let classList = $today.find('[class*="level"]').attr('class').split(/\s+/);

                //on isole la class leveln
                $.each(classList, (index, item) => {
                    if(item.match('^level')) {
                        let strArray = item.split("level");
                        this.eventsNbr = strArray[1];
                    }

                });

                setTimeout(() => {
                    this.showNotification = true;
                }, 1000);
            }
        },
    }
</script>


// WEBPACK FOOTER //
// Calendar.vue?0eeca58a